// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"efa32faf","239":"a619818d","732":"cf3f69ca"}[chunkId] + ".chunk.js";
};